import { LoadingArea } from "@/components/elements/Loading/Loading";
import { EMPTY_STR } from "@/constants/string";
import { useChat } from "@/features/chat/providers/ChatProvider";
import { primary } from "@/theme/colors";
import { openInNewTab } from "@/utils/export";
import { createUrlWithParams } from "@/utils/url";
import { Stack, styled, Typography } from "@mui/material";
import { truncateWithEllipsis } from "@/utils/string";

export const RoomHead = () => {
  const { currentRoom } = useChat();
  const prefecture = currentRoom.roomData?.match?.prefecture;
  const address = currentRoom.roomData?.match?.address;

  if (!currentRoom.roomData)
    return (
      <StyledRoomHead height={118}>
        <LoadingArea />
      </StyledRoomHead>
    );
  return (
    <StyledRoomHead>
      <Typography sx={{ marginBottom: "4px" }} variant="sub16Bold">
        {truncateWithEllipsis(currentRoom?.roomData?.creator?.fullName ?? EMPTY_STR.TEXT, 30)}
      </Typography>
      <Typography
        variant="body14"
        sx={{
          textDecoration: "underline",
          "&:hover": {
            cursor: "pointer",
            opacity: 0.8,
          },
        }}
        onClick={() => {
          const url = process.env.REACT_APP_FRONTEND_MAIN_ROOT_URL;
          return openInNewTab(
            `${createUrlWithParams(`${url}/login`, {
              matchLicenseNumber: currentRoom?.roomData?.match?.matchLicenseNumber,
            })}`,
          );
        }}
      >
        {truncateWithEllipsis(currentRoom.roomData.match?.matchName ?? EMPTY_STR.TEXT, 30)}・ID: {currentRoom.roomData.match?.matchLicenseNumber}
      </Typography>
      <Typography variant="body14">{`${prefecture ?? ""}${address ?? ""}` || EMPTY_STR.TEXT}</Typography>
    </StyledRoomHead>
  );
};

const StyledRoomHead = styled(Stack)`
  padding: 24px 16px;
  border-radius: 8px;
  background-color: ${primary.main};
  color: white;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
